module.exports = __webpack_public_path__ + "img/cookies-illustration.fda979dd.svg";